import { Apollo, gql } from 'apollo-angular';
import { AfterViewInit, Component, ElementRef, Inject, LOCALE_ID, OnInit, Optional, PLATFORM_ID, Renderer2, ViewChild } from '@angular/core';

import {Location, isPlatformServer, isPlatformBrowser} from '@angular/common';
import { GameItem } from 'src/app/apollo/models/base-models';
import { debounceTime, distinctUntilChanged, filter, map, skipWhile, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, combineLatest, zip } from 'rxjs';
import { BaseGamePage } from '../ase-game-page.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ToggleMenuBackService } from 'src/app/services/utils/toggle-menu-back.service';
import { gameInfoTrx, searchGameTrx } from 'src/app/router-translation.labels';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { OpenDesktopDrawerService } from 'src/app/services/utils/open-desktop-drawer.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { DialogClosePreviousUrl } from 'src/app/services/utils/dialog-close-previouse-url.service';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { FilterGamesService } from 'src/app/services/utils/filter-games.service';
import { LICENCE } from 'src/app/global.tokens';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { FrontPageGamesService } from 'src/app/services/page/front-games.service';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { countryFromLocale } from 'src/app/utils/country-from-locale';
import { SearchGameService, SearchConfig, SearchDataItem, SearchConfigFilterItem, GameCategory } from 'src/app/services/games/search-game.service';


const query = gql`query GameSearchList($searchString: String!,$licenseName: Licence!){
  games(first:50,where: {AND: {name_contains: $searchString, OR: [{licenceNew_contains_some: [all,$licenseName]}] } }) {
    id
    name,
    gameid,
    systemName,
    tag,
    hideGame
    thumbnail {
      url
    }
    gameProvider{
          name
          providerExclusionTerritories{
            countryCode
            state
      }
    }
    animation{
      url
      fileName
    }
  }
  }
  `
@Component({
  selector: 'app-search-game',
  templateUrl: './search-game.component.html',
  styleUrls: ['./search-game.component.scss']
})
export class SearchGameComponent extends BaseGamePage implements OnInit, AfterViewInit {

  public searchConfig: SearchConfig = SearchConfig;

  public resultCount: number = 0;

  public searchTerm: string = '';
  public searchPlaceHolder: string = $localize`:@@search-game-placeholder:Search for a game...`;
  public filterItemName: string = '';

  public isLoggedIn: boolean = true;
  public isFilterSelect: boolean = false;
  public isHistory: boolean; //
  public isDesktop: boolean;
  public isInputFocused: boolean = false;
  public isInputSign: boolean = false;

  public gameList: GameItem[];
  public categoryList: GameCategory[];

  private searchSubject = new Subject<string>();
  private unsubscribe$ = new Subject<void>();

  constructor(
    private apollo: Apollo,
    public dialog: MatDialog,
    private toggleBackService: ToggleMenuBackService,
    protected translationConfig: TranslationConfig,
    private route: ActivatedRoute,
    private topDrawerService: OpenDesktopDrawerService,
    private router: Router,
    private location: Location,
    private previousUrl: DialogClosePreviousUrl,
    private minimizeSiteService: MinimizeSiteService,
    public licenceService: LicenceService,
    private filterGameService: FilterGamesService,
    public detectDeviceService: DetectDeviceService,
    private frontPageGamesService: FrontPageGamesService,
    private loginStatusService: LoginStatusService,
    private searchGamesService: SearchGameService,
    @Optional() public dialogRef: MatDialogRef<SearchGameComponent>,
    private elRef: ElementRef,
    private renderer: Renderer2,
    @Inject(LOCALE_ID) public locale: string,
    @Inject(LICENCE) public licence: string,
    @Inject(PLATFORM_ID) public platformId: string,
    @Inject(MAT_DIALOG_DATA) @Optional() public dialogData: any
  ) {
    super(dialog);

    this.isDesktop = detectDeviceService.isDesktop();

    //localStorage.clear()
  }

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;

  ngOnInit(): void {
    this.onGlobalChange().pipe(takeUntil(this.unsubscribe$)).subscribe((resp) => {

      if (this.searchGamesService.isGameItemArray(resp)) {
        this.gameList = this.removeDuplicateGames(resp);
        this.resultCount = this.gameList.length

      } else if (this.searchGamesService.isGameCategoryArray(resp)) {
        const primeCategoryName = this.searchGamesService.getPrimeCategory();

        const primeCategory = (resp as GameCategory[]).find(cat => cat.name === primeCategoryName);

        if (primeCategory) {
          this.categoryList = [primeCategory, ...(resp as GameCategory[]).filter(cat => cat.name !== primeCategoryName)];
        } else {
          this.categoryList = resp;
        }

        this.resultCount = this.categoryList.length

      } else {
        //console.log('undefined type')
      }

      //  console.log('Search result =>', resp);
    })

    this.loadInitialSearchData(this.searchConfig).pipe(takeUntil(this.unsubscribe$)).subscribe(([params, { searchConfig, isHistory }]) => {
      this.setInitialSearchData(params, searchConfig, isHistory)
    })
  }

  ngAfterViewInit(): void {
    this.checkDialog();
  }

  checkDialog() {
    if (this.dialogRef) {
      const dialogContent = this.scrollContainer.nativeElement.closest('.mat-dialog-container');
      //console.log('dialogContent', dialogContent);

      if (dialogContent) {
        this.renderer.listen(dialogContent, 'scroll', () => {
          //console.log('Scroll event detected inside dialog');
          this.handleScroll(dialogContent);
        });
      }

      if (this.dialogRef) {
        this.dialogRef.backdropClick().subscribe(() => {
          this.onCloseEvent();
        });
      }
    }
  }

  handleScroll(target: HTMLElement): void {
    const searchHead = target.querySelector('.search-head') as HTMLElement;
    const searchAction = target.querySelector('.search-action') as HTMLElement;
    const searchBody = target.querySelector('.search-body') as HTMLElement;
    //const searchFilterSheet = target.querySelector('.filter-sheet-wrapper') as HTMLElement;

    const dialogRect = target.getBoundingClientRect();
    const topPosition = dialogRect.top;// + 10;

    if (searchAction) {
      if (target.scrollTop > (searchHead?.offsetHeight ? searchHead.offsetHeight : 0)) {
        //console.log('target.scrollTop', target.scrollTop, 'searchHead?.offsetHeight', searchHead?.offsetHeight)
        searchAction.classList.add('fixed');

        this.renderer.setStyle(searchAction, 'top', `${topPosition}px`);
        this.renderer.setStyle(searchAction, 'padding-bottom', `16px`);
        this.renderer.setStyle(searchBody, 'padding-top', `${searchAction.offsetHeight}px`);
        this.renderer.setStyle(searchAction, 'width', `${target.offsetWidth - 32}px`);
      } else {
        searchAction.classList.remove('fixed');

        this.renderer.setStyle(searchBody, 'padding-top', `0px`);
      }

    }

  }

  onInputFocus(): void {
    this.isInputFocused = true;
    console.log('Input is focused');
  }

  onInputBlur(): void {
    this.isInputFocused = false;
    console.log('Input lost focus');
  }

  /* --------------------------------------------------------------------------------------------------- */

  setInitialSearchData(params: ParamMap, searchConfig: SearchConfig, isHistory: boolean) {
    const searchString = this.searchGamesService.getSearchHistory()
    const searchTerm = decodeURI(params.get('term') || '');
    this.isHistory = isHistory;

    this.searchTerm = searchTerm || searchString;
    this.isInputSign = this.searchTerm ? true : false;
    this.searchGamesService.setSearchFilters(searchConfig.searchFilters);
    this.searchSubject.next(this.searchTerm);

  }

  loadInitialSearchData(searchConfig: SearchConfig) {
    return zip(
      this.route.paramMap,
      this.searchGamesService.getFilters().pipe(
        map((filters) => this.searchGamesService.setFilters(filters, searchConfig)),
        map((filters) => this.searchGamesService.setHistory(searchConfig)),
      )
    );
  }

  /* --------------------------------------------------------------------------------------------------- */

  onOpenGame(gameName: string) {
    this.topDrawerService.close();
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    const urlGameName = gameName;
    this.previousUrl.setUrl(this.location.path().split('/').filter(item => item !== ''));
    this.router.navigate(["", this.translationConfig.getTranslation(gameInfoTrx), urlGameName]);
  }

  onCloseEvent() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }

    this.router.navigate(['/']);
  }

  onFilterSheetClose() {
    this.isFilterSelect = false;
    this.filterItemName = '';

    if (this.isDesktop) {
      setTimeout(() => {
        const dialogContent = this.scrollContainer.nativeElement.closest('.mat-dialog-container');
        dialogContent.scrollTo({ top: 0, behavior: 'smooth' });

        const searchHead = dialogContent.querySelector('.search-head') as HTMLElement;
        const searchAction = dialogContent.querySelector('.search-action') as HTMLElement;
        const searchBody = dialogContent.querySelector('.search-body') as HTMLElement;

        if (searchAction && searchHead && searchBody) {
          //this.renderer.addClass(searchAction, 'fixed');
          //this.renderer.setStyle(searchAction, 'top', `97px`);
          //this.renderer.setStyle(searchAction, 'padding-bottom', `16px`);
          //this.renderer.setStyle(searchBody, 'padding-top', `${searchAction.offsetHeight - searchHead.offsetHeight}px`);
        } else {
          console.error('One or more elements are not found.');
        }
      }, 0);
    } else {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }
  }

  onFilterChoose(filterItem: SearchConfigFilterItem) {
    this.isFilterSelect = true;
    this.filterItemName = filterItem.name;
    this.searchTerm = this.searchGamesService.getSearchHistory()
  }

  onSearchChange(searchString: string) {
    searchString ? this.isInputSign = true : this.isInputSign = false;
    this.searchTerm = searchString;
    //console.log('onSearchChange', searchString, this.isInputSign)

    this.searchSubject.next(searchString);
    this.searchGamesService.saveSearchHistory('');
  }

  onGlobalChange() {
    return combineLatest([
      this.searchGamesService.searchFilters$,
      this.searchSubject.pipe(filter((search) => (search.length >= 4 || !search)), debounceTime(300)),
    ]).pipe(
      //tap(([filterItems, search]) => console.log('move, string =>', search)),
      //filter(([filterItems, search]) => Array.isArray(filterItems) && filterItems.length > 0),
      tap(([filterItems, search]) => { if (!this.isDesktop) { this.location.replaceState(searchGameTrx + '/' + search) }; this.searchTerm = search }),
      //tap(([filterItems, searchString]) => console.log("onGlobalChange: searchString =>", searchString, "filterItems =>", filterItems)),
      //tap(([filterItems, searchString]) => this.searchGamesService.saveSearchHistory(searchString)),  must be saved after
      switchMap(([filterItems, searchString]) => this.searchGames(searchString, filterItems))
    );
  }

  /* --------------------------------------------------------------------------------------------------- */

  searchGames(searchString: string, filterItems: SearchConfigFilterItem[]) {
    for (const filter of filterItems) {
      if ((this.searchGamesService.extractSelectedFilter(filter).length > 0) || searchString) {
        this.isHistory = true;
        break;
      } else {
        this.isHistory = false;
      }
    }

    if (this.isHistory || searchString) {
      return this.searchGamesService.fullSearch(searchString, filterItems);
    } else {
      return this.searchGamesService.initialSearch(filterItems);
    }
  }

  private removeDuplicateGames(games: GameItem[]): GameItem[] {
    const gameIds = new Set();

    return games.filter((game) => {
      if (gameIds.has(game.gameid)) {
        return false;

      } else {
        gameIds.add(game.gameid);
        return true;

      }
    });
  }

  ngOnDestroy() {
    this.searchGamesService.saveSearchHistory('');
    if (isPlatformBrowser(this.platformId)) {
      localStorage?.removeItem(this.searchGamesService.primeCategoryKey);
    }

    this.searchConfig.searchFilters.forEach((filterConfig) => {
      if (isPlatformBrowser(this.platformId)) {
        localStorage?.removeItem(filterConfig.storageKey);
      }
    });

    this.unsubscribe$.next();
    this.unsubscribe$.complete();

  }

  /* --------------------------------------------------------------------------------------------------- */

}
